import { render, staticRenderFns } from "./ImgLibrary.vue?vue&type=template&id=48fc5823&"
import script from "./ImgLibrary.vue?vue&type=script&lang=js&"
export * from "./ImgLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/utils/imgLibrary/ImgLibrary.vue"
export default component.exports